import { safeRange } from "../../../../utils/index.js";
import { uniq } from "es-toolkit";
//#region src/engine/modules/editor/utils/selectRangeColumn.ts
function appendSelectColumns(columnIds, columnId) {
	return uniq([...columnIds, columnId]);
}
function selectRangeColumns(columnIds, fromColumnId, toColumnId) {
	if (!fromColumnId || fromColumnId === toColumnId) return [toColumnId];
	const fromIndex = columnIds.indexOf(fromColumnId);
	const toIndex = columnIds.indexOf(toColumnId);
	if (fromIndex === -1) return [toColumnId];
	return safeRange(fromIndex, toIndex).map((index) => columnIds[index]);
}
function appendSelectRangeColumns(columnIds, selectColumnIds, fromColumnId, toColumnId) {
	return uniq([...selectColumnIds, ...selectRangeColumns(columnIds, fromColumnId, toColumnId)]);
}
//#endregion
export { appendSelectColumns, appendSelectRangeColumns, selectRangeColumns };
